// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.forecast-info[data-v-7fdfa2a1] {\n  color: #45aaf2\n}\n", ""]);
// Exports
module.exports = exports;
